export const getMe = (store) => store.user.me;
export const isMeFetched = (store) => store.user.me.fetched;
export const getMeId = (store) => store.user.me.data.id;
export const getFeatureToggles = (state) => state.user.featureToggles.flags || [];
export const isFeatureEnabled = (feature) => (state) => (state.user.featureToggles.flags || []).includes(feature);
export const areFeatureTogglesFetched = (state) => state.user.featureToggles.fetched;
